<template>
    <div>
        <h1 align="center">
            <strong><u>DISCLAIMER</u></strong>
        </h1>

        <p>
            <strong><u>About us</u></strong>            <strong>:</strong>

        </p>
        <p>
            TravelQuest is a gaming marketplace, where we allow Creators to create,
            host and sell games. Games can be made up of various missions, which may
            include activities, such as, submitting photos or videos, checking-in at
            specific locations, or solving puzzles or riddles in order to receive
            points. These games may be played with a closed user group and/or with the
            Internet community. (<strong>“Service”</strong>)
        </p>

        <p>
            <strong><u>Acceptance</u></strong> <strong>:</strong>
        </p>
        <p>
            In case you are a user, your relationship with the us shall be governed
            by this <strong>Disclaimer</strong>, and our <strong>Terms of Use,</strong><strong>Privacy Policy</strong> statement and    <strong>Cookie Policy</strong> displayed on the website and app. And in
            case you a Creator, your relationship with the us shall be governed by    <strong>Creator Terms</strong>, in addition to all the above-mentioned
            policies. By accessing and/or using the Website and its Services, you
            accept and agree with this <strong>Disclaimer</strong>, and all our terms
            and conditions.
        </p>
        <p>
            <strong><u>Disclaimer</u></strong>
            <strong>:</strong>
        </p>
        <p>
            a) We are a marketplace platform that connects Creators with the users or
            players. You acknowledge and undertake that you are accessing the games
            available on the website or app and transacting at your own risk and are
            using your best and prudent judgment before entering into any transactions
            through the website or app with any third party. We do not verify the
            background of the Creators, their games or activities in their games or any
            other content of theirs. Similarly, we do not verify the background or
            genuineness of the users or players, and therefore we disclaim all
            warranties or guarantees in this respect whatsoever. We shall neither be
            liable nor responsible for any actions or inactions of Creators or users,
            nor any breach of conditions, representations or warranties by the Creators
            or users, and hereby expressly disclaim any and all responsibility and
            liability in that regard.
            <strong>
                <em>
                    <u>
                        We shall not mediate or resolve or be a party to any dispute or
                        disagreement between the Creators and the users/players.
                    </u>
                </em>
            </strong>
        </p>
        <p>
            b) When a game is listed/available on the Platform by a Creator, the
            tickets purchased by the user from the Creators will be governed by the
            bipartite contractual arrangement entered into directly between the user
            and the Creator. User agrees that TravelQuest cannot and does not confirm
            each Creator or user’s purported identity. TravelQuest encourages users and
            Creators to exercise discretion and caution while dealing with each other.
            You must be at least of the age of majority as per the laws of the
            jurisdiction in which you reside, in order to use our platform or purchase
            the game tickets. In case you are not of the age of majority, then you must
            have the permission of your lawful guardian to use and access our Platform,
            buy the ticket, and participate in the activities, under their strict
            supervision.
        </p>
        <p>
            c) The games for which the users purchase the ticket, are created by the
            Creators, and TravelQuest expressly disclaims all warranties and guarantees
            in respect of such game and its activities, as the same is out of our
            control. More specifically, we cannot guarantee that the game will not
            contain violence, nudity, obscenity, adult content, immorality, illegality,
            hateful activity, misinformation, harassment, self-injury and harmful
            content. We also cannot guarantee that the game will not expose you to
            activities that are harmful, dangerous, illegal, immoral, harassing, and
            hateful. However, we are strictly against this, and if you notice any such
            activity in the game, please report it to us, at    <strong>dan@travelAndquest.com.</strong>
        </p>
        <p>
            d) The site, its services, and games are provided on an    <strong>“as-is”</strong> and <strong>“as available”</strong> basis, and
            TravelQuest (and our licensors and affiliates) expressly disclaims any and
            all warranties and conditions of any kind, whether express, implied, or
            statutory, including all warranties or conditions of quality, suitability,
            accuracy, reliability, completeness, timeliness, performance, safety,
            merchantability, fitness for a particular purpose, title, quiet enjoyment,
            accuracy, or non-infringement of the services listed on our Platform. We
            make no warranty that the Site or service or games will meet your
            requirements, will be available on an uninterrupted, timely, secure, or
            error-free basis, or will be accurate, reliable, free of viruses or other
            harmful code, complete, legal, or safe.
        </p>
        <p>
            e) You hereby waive your right to sue us for any actions, inactions or
            breach of contract by Creator or the user, as the case may be.
        </p>
        <p>
            <strong>Contact Us: </strong>
            For any query or assistance, please write us at dan@travelAndquest.com.
        </p>

    </div>
</template>

<script>
export default {
    name: "v_Terms_CookiePolicy"
}
</script>

<style scoped>
p{
    margin: 16px;
}
</style>